import React from "react"

import { AnimatedModal } from "../../../../components/shared/Modal"

/**
 * ConfirmSaveModal - Modal de confirmación para guardar cambios
 * Se muestra cuando el usuario hace clic en "Save" para confirmar la acción
 *
 * @param {boolean} visible - Si el modal está visible
 * @param {function} onClose - Callback cuando el usuario cancela (No)
 * @param {function} onConfirm - Callback cuando el usuario confirma (Yes)
 */
const ConfirmSaveModal = ({
  visible,
  onClose,
  onConfirm,
  title = "Save changes?",
  message = "Are you sure you want to save these changes?",
  confirmLabel = "Yes",
  cancelLabel = "No"
}) => (
  <AnimatedModal
    visible={visible}
    hideModal={onClose}
    showFooter={false}
    hideCloseButton={false}
    dialogClassName="w-[560px] md:w-full">
    {/* Header */}
    <div className="relative mb-2 w-full shrink-0 font-['Manrope:Bold',_sans-serif] text-[20px] font-bold leading-[28px] text-[#0b3954]">
      {title}
    </div>

    {/* Message */}
    <div className="relative mb-6 w-full shrink-0 font-['Manrope:Regular',_sans-serif] text-[16px] font-normal leading-[24px] text-[#55778a]">
      {message}
    </div>

    {/* Divider */}
    <div className="mb-6 w-full border-t border-[#e4eff6]" />

    {/* Buttons */}
    <div className="flex w-full items-center justify-end gap-3">
      <button
        onClick={onClose}
        className="relative box-border flex shrink-0 cursor-pointer flex-row content-stretch items-center justify-center gap-2 overflow-visible rounded border border-[#c8d6df] bg-white px-4 py-0 transition-colors hover:bg-gray-50">
        <div className="relative shrink-0 text-nowrap text-left font-['Manrope:Bold',_sans-serif] text-[16px] font-bold leading-[0] text-[#0b3954]">
          <p className="block whitespace-pre leading-[40px]">{cancelLabel}</p>
        </div>
      </button>
      <button
        onClick={onConfirm}
        className="relative box-border flex shrink-0 flex-row content-stretch items-center justify-center gap-2 rounded bg-[#0d9da4] px-4 py-0 transition-colors hover:bg-[#0b8a90]">
        <div className="relative shrink-0 text-nowrap text-left font-['Manrope:Bold',_sans-serif] text-[16px] font-bold leading-[0] text-white">
          <p className="block whitespace-pre leading-[40px]">{confirmLabel}</p>
        </div>
      </button>
    </div>
  </AnimatedModal>
)

export default ConfirmSaveModal
